import { FC } from "react";
import gsap from "gsap";
import { BaseProps } from "./text";
import GText from "./GText";
import useScrollTrigger from "../../functions/useScrollTrigger";
import { css } from "@emotion/react";

interface Props {
  text?: string;
  secondaryText?: string;
  secondaryFontSize?: number;
  secondaryColor?: string;
  curtainColor?: string;
}

const GTextReveal: FC<Props & BaseProps> = (props) => {
  const styles = css`
    & .first {
      color: ${props.color};
      font-size: inherit;
      font-family: inherit;
      line-height: 1;
      margin-bottom: 0;
      margin-top: 0;
    }

    & .second {
      margin: 0;
      font-size: ${props.secondaryFontSize ?? 18}px;
      color: ${props.secondaryColor ?? "#000"};
      font-family: inherit;
    }

    & .js-text-effect {
      position: relative;
      width: fit-content;
      transform: translatey(20px);
      opacity: 0;
      visibility: hidden;
      overflow: hidden;
      --translateX: 0;

      &::before {
        position: absolute;
        left: 0;
        top: 0;
        content: "";
        width: 100%;
        height: 100%;
        background: ${props.curtainColor};
        transform: translateX(var(--translateX));
      }
    }
  `;

  const { ref } = useScrollTrigger(() => {
    const tl = gsap.timeline();

    const moveAnimation = {
      y: 0,
      autoAlpha: 1,
      duration: 0.5,
    };
    const revealAnimation = {
      "--translateX": "110%",
      duration: 0.5,
      delay: 0.3,
    };

    tl.to(".g-text-reveal .js-text-effect.first", moveAnimation)
      .to(".g-text-reveal .js-text-effect.first", revealAnimation)
      .to(".g-text-reveal .js-text-effect.second", moveAnimation, "-=1.2s")
      .to(".g-text-reveal .js-text-effect.second", revealAnimation, "-=.8s");
  });

  return (
    <GText {...props}>
      <div ref={ref} className="g-text-reveal" css={styles}>
        <h2 className="js-text-effect first">{props.text}</h2>
        <p className="js-text-effect second">{props.secondaryText}</p>
      </div>
    </GText>
  );
};

GTextReveal.defaultProps = {
  text: "Subscribe",
  secondaryText: "Grooody",
  color: "#000",
  once: true,
  fontSize: 50,
  secondaryFontSize: 18,
  curtainColor: "red",
};

export default GTextReveal;

// We need to add the below in framer
/*

addPropertyControls(TextReveal, {
    text: {
        title: "Text",
        type: ControlType.String,
        defaultValue: "Subscribe to Grooody",
    },
    secondaryText: {
        title: "Text 2",
        type: ControlType.String,
        defaultValue: "Subscribe to Grooody",
    },
    color: {
        title: "Color",
        type: ControlType.Color,
        defaultValue: "#000",
    },
    letterSpacing: {
        title: "Letter",
        type: ControlType.Number,
    },
    fontSize: {
        title: "Font Size",
        type: ControlType.Number,
        defaultValue: 63,
    },
    secondaryFontSize: {
        title: "Text 2 Font Size",
        type: ControlType.Number,
        defaultValue: 48,
    },
    fontFamily: {
        title: "Font Family",
        type: ControlType.Font,
        defaultValue: "Sigmar",
    },
})

*/
